// TprSheet.jsx
import React, { useEffect, useState, useRef } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Swal from "sweetalert2";
import DataTable from "react-data-table-component";

function TprSheet() {
  const [ldata, setLdata] = useState(null);
  const [otUhidSuggestions, setOtUhidSuggestions] = useState([]);
  const [dropdownOpenIndex, setDropdownOpenIndex] = useState(null);
  const [loadingList, setLoadingList] = useState(false);
  const [list, setList] = useState([]);
  const hasLoadedPrefill = useRef(false);

  const [image, setImage] = useState("");
  const [watermarkImage, setWatermarkImage] = useState("");
  const [footerImage, setFooterImage] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const [lastSavedTpaId, setLastSavedTpaId] = useState(null);

  const [formData, setFormData] = useState({
    doc: [],
    wards: [],
    page_no: 0,
    tpa_id: "",
    tpa_ipd_number: "",
    tpa_patient: "",
    tpa_consultant: "",
    tpa_ot_doctor: "",
    tpa_trp: "",
    tpa_temprature: "",
    tpa_bp: "",
    tpa_fluid: "",
    tpa_spo2: "",
    tpa_uhid: "",
    tpa_room: "",
    tpa_bed: "",
    tpa_panel: "",
    tpa_date: "",
    tpa_time: "",
    tpa_pulse: "",
    tpa_stool: "",
    tpa_weight: "",
    tpa_repritation: "",
    tpa_urine: "",
    tpa_cvp: "",
    tpa_user: "",
    tpa_notes: "",
    alertMsg: "",
    alertMsgTyp: "",
    search_key: "",
    isAlert: false,
  });

  // ---------------------
  // Load prefill from sessionStorage
  // ---------------------
 // Around line 67-80, update the prefill useEffect:
 useEffect(() => {
  if (hasLoadedPrefill.current) return;

  const raw = sessionStorage.getItem("tpr_prefill");
  if (!raw) return;

  const loadPrefill = async () => {
    try {
      const prefill = JSON.parse(raw);
      console.log("🔍 TPR prefill loaded:", prefill);

      setFormData((prev) => ({
        ...prev,
        tpa_ipd_number: prefill.ipd_uhid || prefill.uhid || prefill.ot_uhid_no || "",
        tpa_patient: prefill.ipd_patient_name || prefill.name || prefill.ot_patient_name || "",
        
        // Store IDs
        tpa_consultant: prefill.ot_ref_doctor || prefill.ipd_refer_doctor || prefill.refer_doctor || "",
        tpa_ot_doctor: prefill.ot_doctor || "",
        
        tpa_room: prefill.ipd_ward || "",
        tpa_bed: prefill.ipd_bed || "",
      }));

      toast.info("Patient data loaded from IPD/OT");
      hasLoadedPrefill.current = true;

      // Wait a moment for state to update, then resolve doctor names
      await new Promise(resolve => setTimeout(resolve, 200));
      await resolveDoctorNamesForForm();

      sessionStorage.removeItem("tpr_prefill");
    } catch (err) {
      console.error("Error loading TPR prefill:", err);
    }
  };

  loadPrefill();
}, []);

  // ---------------------
  // Basic handlers
  // ---------------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ---------------------
  // Submit/create TPA
  // ---------------------
  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData();
  
    // Validation
    if (!formData.tpa_ipd_number || !formData.tpa_patient) {
      toast.error("UHID and Patient Name are required");
      return;
    }
  
    // append all fields
    [
      "tpa_id",
      "tpa_ipd_number",
      "tpa_patient",
      "tpa_consultant",
      "tpa_ot_doctor",
      "tpa_trp",
      "tpa_temprature",
      "tpa_bp",
      "tpa_fluid",
      "tpa_spo2",
      "tpa_uhid",
      "tpa_room",
      "tpa_bed",
      "tpa_panel",
      "tpa_date",
      "tpa_time",
      "tpa_pulse",
      "tpa_stool",
      "tpa_weight",
      "tpa_repritation",
      "tpa_urine",
      "tpa_cvp",
      "tpa_notes",
    ].forEach((k) => {
      fd.append(k, formData[k] ?? "");
    });
  
    fd.append("tpa_user", ldata?.user_id ?? "");
  
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.addTpaUrl2, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
  
      console.log("📋 Backend response:", response.data); // Debug log
  
      if (response.data && response.data.status) {
        const tpaRow = response.data.tpa_dt || response.data.tpa || null;
        const returnedId = tpaRow?.tpa_id || response.data.tpa_id || null;
  
        console.log("✅ Returned TPR record:", tpaRow); // Debug log
        console.log("✅ TPR Number:", tpaRow?.tpa_trp); // Debug log
  
        if (returnedId) {
          setLastSavedTpaId(returnedId);
        }
  
        // ✅ FIX: Properly merge the returned record into formData
        if (tpaRow) {
          setFormData((prev) => {
            const updated = {
              ...prev,
              ...tpaRow, // Merge all fields from backend
              // Explicitly set critical fields to ensure they update
              tpa_id: tpaRow.tpa_id || prev.tpa_id,
              tpa_trp: tpaRow.tpa_trp || prev.tpa_trp, // ✅ TPR number
              tpa_consultant_name: tpaRow.tpa_consultant_name || prev.tpa_consultant_name,
              tpa_ot_doctor_name: tpaRow.tpa_ot_doctor_name || prev.tpa_ot_doctor_name,
              isAlert: true,
              alertMsg: response.data.success,
              alertMsgTyp: response.data.type,
            };
            
            console.log("✅ Updated formData with TPR:", updated.tpa_trp); // Debug log
            return updated;
          });
        }
  
        toast.success(response.data.success || "Saved");
        initData(); // Refresh the list
      } else {
        toast.error(response.data?.success || "Failed to save");
      }
    } catch (error) {
      console.error("create tpa error:", error);
      toast.error("Network error while saving.");
    }
  };

  // ---------------------
  // Init data - TPA list
  // ---------------------
  const initData = async () => {
    setLoadingList(true);

    try {
      const storedData = sessionStorage.getItem("ldata");
      const userData = storedData ? JSON.parse(storedData) : null;
      const roleId = userData?.role_id;
      setIsAdmin(roleId === 1 || roleId === "1");
      if (storedData) setLdata(userData);

      const fd = new FormData();
      fd.append("page_no", "none");
      fd.append("search_key", String(formData.search_key ?? ""));
      fd.append("tpa_user", "all");
      const todayIso = new Date().toISOString().split("T")[0];
const dateFrom = (formData.date_from && formData.date_from.trim()) ? formData.date_from : todayIso;
const dateTo   = (formData.date_to   && formData.date_to.trim())   ? formData.date_to   : todayIso;

fd.append("date_from", String(dateFrom));
fd.append("date_to", String(dateTo));
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTpaListUrl2, fd, {
        headers: { "Content-Type": "multipart/form-data" },
        timeout: 20000,
      });

      if (!response || !response.data) {
        setList([]);
        setLoadingList(false);
        return;
      }

      const data = response.data;
      if (!data.status) {
        console.warn("Server returned status=false", data);
        setList([]);
        setLoadingList(false);
        return;
      }

      let records = data.records ?? [];
      if (!Array.isArray(records) && records && typeof records === "object") {
        const vals = Object.values(records);
        records = Array.isArray(vals) ? vals : [];
      }
      if (!Array.isArray(records)) records = [];

      records = records.map((r) => (r && typeof r === "object" ? r : { _raw: r }));

      setList(records);

      if (data.page_no !== undefined) {
        setFormData((prev) => ({ ...prev, page_no: data.page_no }));
      }
    } catch (err) {
      console.error("initData error:", err);
      setList([]);
    } finally {
      setLoadingList(false);
    }
  };

  // ---------------------
  // Fetch single tpa by id
  // ---------------------
  const fetchTpaById = async (tpaId) => {
    if (!tpaId) return null;
    try {
      const fd = new FormData();
      fd.append("tpa_id", String(tpaId));
      const res = await axios.post(AppConst.BASE_URL + AppConst.getTpaByIdUrl, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data && res.data.status && res.data.tpa_dt) {
        return res.data.tpa_dt;
      }
      return res.data?.tpa_dt || null;
    } catch (err) {
      console.error("fetchTpaById error:", err);
      return null;
    }
  };

  // ---------------------
  // Fetch all doctors (users)
  // ---------------------
  // ---------------------
// Fetch all doctors (users)
// ---------------------



// try all plausible id keys and name keys and return first match
// robust resolver: try many possible id/name shapes
function resolveDoctorNameById(id, docs = []) {
  if (!id && id !== 0) return "";
  const idStr = String(id);
  
  console.log(`🔍 Searching for doctor ID: ${idStr} in ${docs.length} doctors`);
  
  // Primary lookup by user_id (this is what OT Management uses)
  const doc = docs.find((d) => String(d.user_id) === String(idStr));
  
  if (doc) {
    const name = doc.fname || doc.name || doc.full_name || "";
    console.log(`✅ FOUND doctor: ${name} for ID: ${idStr}`);
    return name;
  }
  
  console.log(`❌ Doctor ID ${idStr} NOT FOUND`);
  return "";
}

function getDoctorNameById(id) {
  if (!id) return "";
  const docs = Array.isArray(formData.doc) ? formData.doc : [];
  const doc = docs.find((d) => String(d.user_id) === String(id));
  return doc ? (doc.fname || doc.name || "") : "";
}

const fetchAllDoctors = async () => {
  try {
    const fd = new FormData();
    fd.append("type", "doctor");
    fd.append("search_key", "");
    fd.append("page_no", "none"); // Important: get ALL doctors

    const res = await axios.post(AppConst.BASE_URL + AppConst.getUserListUrl, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    const records = (res?.data?.status && Array.isArray(res.data.records)) ? res.data.records : [];
    console.log("✅ fetchAllDoctors -> total doctors:", records.length);
    if (records.length > 0) {
      console.log("📋 Doctor record structure:", records[0]);
      console.log("📋 Doctor IDs in list:", records.slice(0, 5).map(d => `${d.user_id}: ${d.fname}`));
    }
    
    setFormData((prev) => ({ ...prev, doc: records }));
    return records;
  } catch (err) {
    console.error("❌ fetchAllDoctors error:", err);
    setFormData((prev) => ({ ...prev, doc: [] }));
    return [];
  }
};



  // ---------------------
  // Fetch wards/beds list
  // ---------------------
  const initData3 = async () => {
    const fd = new FormData();
    fd.append("par_by", "1");
    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.getBedListUrl1, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status) {
        setFormData((prev) => ({ ...prev, wards: response.data.records || [] }));
      } else {
        setFormData((prev) => ({ ...prev, wards: [] }));
      }
    } catch (error) {
      console.error("initData3 error:", error);
    }
  };

  // ---------------------
  // Delete item
  // ---------------------
  const delItem = async (editItem) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Delete this TPR record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
  
    if (!confirm.isConfirmed) return;
  
    const fd = new FormData();
    fd.append("tpa_id", String(editItem.tpa_id));
  
    try {
      // disable interactions briefly
      setLoadingList(true);
  
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.delTpaUrl2,
        fd,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
  
      // ALWAYS log response for debugging
      console.log("delItem response:", response?.data);
  
      // Use safe checks
      const resData = response?.data || {};
      if (resData.status) {
        toast.success(resData.success || "Deleted");
  
        // small delay so DB changes are visible when we re-fetch
        setTimeout(() => {
          initData();
        }, 300);
      } else {
        // Show server-provided message if any
        toast.error(resData.success || "Delete failed");
        // still re-fetch just in case (optional)
        setTimeout(() => initData(), 500);
      }
    } catch (error) {
      console.error("delItem error:", error, error?.response?.data);
      // try to show a server message when possible
      const msg = error?.response?.data?.success || "Network error while deleting.";
      toast.error(msg);
      // re-fetch to reflect true state
      setTimeout(() => initData(), 500);
    } finally {
      setLoadingList(false);
    }
  };
  

  // ---------------------
  // Component mount
  // ---------------------
  useEffect(() => {
    const storedData = sessionStorage.getItem("ldata");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setLdata(parsed);
    }
    initData();
    fetchAllDoctors();
    initData3();
    fetchConfigData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------------
  // Search UHID suggestions
  // ---------------------
  const searchOtUserNow = async (e) => {
    const typed = e.target.value;
    const uhid = typed.trim();

    setFormData((prev) => ({ ...prev, tpa_ipd_number: typed }));

    if (uhid.length < 3) {
      setOtUhidSuggestions([]);
      return;
    }

    try {
      const fd = new FormData();
      fd.append("lab_reg_uhid", uhid);

      const response = await axios.post(AppConst.BASE_URL + AppConst.searchUhidUrlCall, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.status) {
        setOtUhidSuggestions(response.data.records || []);
      } else {
        setOtUhidSuggestions([]);
      }
    } catch (error) {
      console.error("OT UHID Search Error:", error);
      setOtUhidSuggestions([]);
    }
  };

  const handleSelectOtUser = async (user) => {
    if (!user) return;
  
    try {
      // 1) Fetch OT details
      let finalUser = { ...user };
      const uhid = user.lab_reg_uhid || user.ipd_uhid || user.ot_uhid_no || "";
  
      if (uhid) {
        try {
          const otFd = new FormData();
          otFd.append("ot_uhid_no", uhid);
          const otResponse = await axios.post(
            AppConst.BASE_URL + AppConst.getOtByUhidUrl,
            otFd,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          if (otResponse?.data?.status && otResponse.data.ot_dt) {
            finalUser = { ...finalUser, ...otResponse.data.ot_dt };
            console.log("✅ OT response:", otResponse.data.ot_dt);
          }
        } catch (err) {
          console.log("No OT record found for this UHID");
        }
      }
  
      // 2) Ensure doctor list is loaded
      let docs = formData.doc;
      if (!docs || docs.length === 0) {
        console.log("📋 Fetching doctor list...");
        docs = await fetchAllDoctors();
      }
      
      console.log(`📋 Doctor list available: ${docs.length} doctors`);
      if (docs.length > 0) {
        console.log("📋 Sample doctor record:", docs[0]);
      }
  
      // 3) Get doctor IDs from backend
      const consultantId = finalUser.ot_ref_doctor || finalUser.ipd_refer_doctor || "";
      const otDoctorId = finalUser.ot_doctor || "";
  
      console.log("🔍 Looking for doctors:");
      console.log("   Consultant ID:", consultantId);
      console.log("   OT Doctor ID:", otDoctorId);
  
      // 4) Resolve names using the same pattern as OT Management
      const consultantName = resolveDoctorNameById(consultantId, docs);
      const otDoctorName = resolveDoctorNameById(otDoctorId, docs);
  
      console.log("👨‍⚕️ Resolved names:");
      console.log("   Consultant:", consultantName);
      console.log("   OT Doctor:", otDoctorName);
  
      // 5) Update form
      setFormData((prev) => ({
        ...prev,
        tpa_ipd_number: finalUser.lab_reg_uhid || finalUser.ipd_uhid || finalUser.ot_uhid_no || "",
        tpa_patient: finalUser.lab_reg_name || finalUser.ipd_patient_name || finalUser.ot_patient_name || "",
  
        // Store IDs for backend
        tpa_consultant: consultantId,
        tpa_ot_doctor: otDoctorId,
  
        // Store names for display
        tpa_consultant_name: consultantName,
        tpa_ot_doctor_name: otDoctorName,
  
        tpa_room: finalUser.ipd_ward || "",
        tpa_bed: finalUser.ipd_bed || "",
        tpa_temprature: finalUser.ipd_temprature || "",
        tpa_bp: finalUser.ipd_bp || "",
        tpa_fluid: finalUser.ipd_fluid || "",
        tpa_spo2: finalUser.ipd_spo2 || "",
        tpa_panel: finalUser.ipd_panel || "",
        tpa_pulse: finalUser.ipd_pulse || "",
        tpa_stool: finalUser.ipd_stool || "",
        tpa_weight: finalUser.ipd_weight || "",
        tpa_repritation: finalUser.ipd_repritation || "",
        tpa_urine: finalUser.ipd_urine || "",
        tpa_cvp: finalUser.ipd_cvp || "",
      }));
  
      toast.success("Patient data loaded successfully!");
    } catch (err) {
      console.error("❌ Error loading patient data:", err);
      toast.error("Failed to load patient data.");
    } finally {
      setOtUhidSuggestions([]);
    }
  };
  // Add this function after fetchAllDoctors
// Add this helper function RIGHT AFTER fetchAllDoctors function
const resolveDoctorNamesForForm = async () => {
  console.log("🔄 resolveDoctorNamesForForm called");
  
  // Ensure doctors are loaded
  let docs = formData.doc;
  if (!docs || docs.length === 0) {
    console.log("⚠️ No doctors in formData.doc, fetching...");
    docs = await fetchAllDoctors();
  }

  console.log("📋 Total doctors available:", docs.length);
  console.log("🔍 Current consultant ID:", formData.tpa_consultant);
  console.log("🔍 Current OT doctor ID:", formData.tpa_ot_doctor);

  // Resolve consultant name if we have an ID
  if (formData.tpa_consultant && !formData.tpa_consultant_name) {
    const consultantName = resolveDoctorNameById(formData.tpa_consultant, docs);
    console.log("👨‍⚕️ Resolved consultant name:", consultantName);
    if (consultantName) {
      setFormData(prev => ({ ...prev, tpa_consultant_name: consultantName }));
    } else {
      console.log("❌ Could not resolve consultant name for ID:", formData.tpa_consultant);
    }
  }

  // Resolve OT doctor name if we have an ID
  if (formData.tpa_ot_doctor && !formData.tpa_ot_doctor_name) {
    const otDoctorName = resolveDoctorNameById(formData.tpa_ot_doctor, docs);
    console.log("👨‍⚕️ Resolved OT doctor name:", otDoctorName);
    if (otDoctorName) {
      setFormData(prev => ({ ...prev, tpa_ot_doctor_name: otDoctorName }));
    } else {
      console.log("❌ Could not resolve OT doctor name for ID:", formData.tpa_ot_doctor);
    }
  }
};

  // ---------------------
  // Helpers for doctor/ward/bed name lookups
  // ---------------------
  function getDoctorById(id) {
    if (id === null || id === undefined) return null;
    const idStr = String(id);
    const docs = Array.isArray(formData.doc) ? formData.doc : [];

    for (const d of docs) {
      if (!d) continue;
      if (String(d.user_id) === idStr) return d;
      if (d.doc && String(d.doc.doc_id) === idStr) return d.doc;
    }
    return null;
  }

  function getDoctorNameById(id) {
    const doc = getDoctorById(id);
    if (!doc) return "";
    return doc.fname || doc.name || "";
  }

  function getWardNameById(wardId) {
    const wards = Array.isArray(formData.wards) ? formData.wards : [];
    const ward = wards.find((w) => String(w.cat_id) === String(wardId));
    return ward ? ward.cat_name : "";
  }

  function getBedNameById(bedId) {
    const wards = Array.isArray(formData.wards) ? formData.wards : [];
    for (let ward of wards) {
      if (!ward || !Array.isArray(ward.beds)) continue;
      const bed = ward.beds.find((b) => String(b.bed_id) === String(bedId));
      if (bed) return bed.bed_name || "";
    }
    return bedId || "";
  }
  function todayIsoDate() {
    return new Date().toISOString().split("T")[0]; // "YYYY-MM-DD"
  }
  
  // ---------------------
  // Set form date/time default on mount
  // ---------------------
  // ---------------------
// Set form date/time default on mount (and default list filter to today)
// ---------------------
useEffect(() => {
  const today = new Date();
  const formattedDate = today.toISOString().split("T")[0]; // YYYY-MM-DD
  const formattedTime = today.toTimeString().slice(0, 5);   // HH:MM

  setFormData((prev) => ({
    ...prev,
    tpa_date: prev.tpa_date || formattedDate,
    tpa_time: prev.tpa_time || formattedTime,
    // If date_from/date_to not set, default both to today so the list shows today's records
    date_from: prev.date_from || formattedDate,
    date_to: prev.date_to || formattedDate,
  }));
}, []);


const handleCancel = () => {
  const today = todayIsoDate();
  setFormData((prev) => ({
    ...prev,
    tpa_id: "",
    tpa_ipd_number: "",
    tpa_patient: "",
    tpa_consultant: "",
    tpa_trp: "",
    tpa_temprature: "",
    tpa_bp: "",
    tpa_fluid: "",
    tpa_spo2: "",
    tpa_bed: "",
    tpa_room: "",
    tpa_panel: "",
    tpa_pulse: "",
    tpa_stool: "",
    tpa_weight: "",
    tpa_repritation: "",
    tpa_urine: "",
    tpa_cvp: "",
    tpa_notes: "",
    // ensure list filter shows today's records too
    date_from: today,
    date_to: today,
  }));
  hasLoadedPrefill.current = false;
  // optional: refresh list if you'd like immediate reload
  initData();
};

// -----------------------
// Auto-search when date range changes
// -----------------------
useEffect(() => {
  if (formData.date_from || formData.date_to) {
    initData();
  }
}, [formData.date_from, formData.date_to]);

  // ---------------------
  // Fetch config (logos etc.)
  // ---------------------
  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data.status) {
        const data = res.data;
        setImage(data.header_logo || "");
        setWatermarkImage(data.logo || "");
        setFooterImage(data.footer_logo || "");
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };
// Add this function after your other helper functions (like getWardNameById, getBedNameById)
function formatTimeTo12Hour(time24) {
  if (!time24) return "";
  
  try {
    // time24 is in format "HH:mm" like "14:30"
    const [hours, minutes] = time24.split(":");
    let hour = parseInt(hours);
    const minute = minutes || "00";
    
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12; // 0 should be 12
    
    return `${hour}:${minute} ${ampm}`;
  } catch (e) {
    return time24; // Return original if parsing fails
  }
}


// Add this function after formatTimeTo12Hour
function formatDateToDDMMMYYYY(dateString) {
  if (!dateString) return "";
  
  try {
    // dateString is in format "YYYY-MM-DD" like "2025-10-03"
    const date = new Date(dateString);
    
    const day = String(date.getDate()).padStart(2, '0');
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch (e) {
    return dateString; // Return original if parsing fails
  }
}
  // ---------------------
  // Convert image URL to base64
  // ---------------------
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url, { cache: "no-cache" });
      if (!response.ok) return null;
      const blob = await response.blob();
      if (!blob.type.startsWith("image/")) return null;
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("imageUrlToBase64 error:", error);
      return null;
    }
  };

  // ---------------------
  // Generate PDF (current formData)
  // ---------------------
  const generatePDF = async () => {
    if (!formData.tpa_patient) {
      Swal.fire("Error", "Patient data is not available.", "error");
      return;
    }
  
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    let y;
  
    const headerImageBase64 = await imageUrlToBase64(image);
    const headerImageHeight = 30;
    if (headerImageBase64) {
      doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
    }
    y = headerImageHeight + 8;
  
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("NURSING MONITORING SHEET", pageWidth / 2, y, { align: "center" });
    y += 8;
  
    // ✅ Get doctor names
    const consultantName = formData.tpa_consultant_name || 
                           getDoctorNameById(formData.tpa_consultant) || 
                           "N/A";
    
    const surgeonName = formData.tpa_ot_doctor_name || 
                        getDoctorNameById(formData.tpa_ot_doctor) || 
                        "N/A";
  
    // ✅ Convert time to 12-hour format
    const time12Hour = formatTimeTo12Hour(formData.tpa_time);
    const formattedDate = formatDateToDDMMMYYYY(formData.tpa_date);
    const patientDetailsBody = [
      [
        { content: "UHID", styles: { fontStyle: "bold" } }, 
        `: ${formData.tpa_ipd_number || "N/A"}`, 
        { content: "TPR No", styles: { fontStyle: "bold" } }, 
        `: ${formData.tpa_trp || "-"}`
      ],
      [
        { content: "Patient Name", styles: { fontStyle: "bold" } }, 
        `: ${formData.tpa_patient || "N/A"}`, 
        { content: "Ward / Bed", styles: { fontStyle: "bold" } }, 
        `: ${getWardNameById(formData.tpa_room) || "N/A"} / ${getBedNameById(formData.tpa_bed) || "-"}`
      ],
      [
        { content: "Consultant", styles: { fontStyle: "bold" } }, 
        `: ${consultantName}`,
        { content: "Surgeon", styles: { fontStyle: "bold" } }, 
        `: ${surgeonName}`
      ],
      [
        { content: "Report Date", styles: { fontStyle: "bold" } }, 
      `: ${formattedDate || "N/A"}`, 
        { content: "Report Time", styles: { fontStyle: "bold" } }, 
        `: ${time12Hour || "N/A"}` // ✅ Changed to 12-hour format
      ]
    ];
  
    autoTable(doc, {
      body: patientDetailsBody,
      startY: y,
      theme: "plain",
      styles: { fontSize: 10, cellPadding: 1 },
      columnStyles: { 
        0: { cellWidth: 30 }, 
        1: { cellWidth: 65 }, 
        2: { cellWidth: 30 }, 
        3: { cellWidth: "auto" } 
      },
    });
    y = doc.lastAutoTable.finalY + 10;
  
    // ... rest of your PDF generation code stays the same ...
    
    doc.setFontSize(12).setFont("helvetica", "bold");
    doc.text("Vital Signs", 15, y);
    y += 3;
  
    const vitalsBody = [
      ["Pulse", formData.tpa_pulse || "-", "Temperature", formData.tpa_temprature || "-"],
      ["Blood Pressure (BP)", formData.tpa_bp || "-", "SpO2", formData.tpa_spo2 || "-"],
      ["Respiration", formData.tpa_repritation || "-", "Weight", formData.tpa_weight || "-"],
    ];
  
    autoTable(doc, {
      body: vitalsBody,
      startY: y,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 2, halign: "center" },
      headStyles: { fillColor: [220, 220, 220], textColor: 20 },
      columnStyles: { 0: { fontStyle: "bold", halign: "left" }, 2: { fontStyle: "bold", halign: "left" } },
    });
    y = doc.lastAutoTable.finalY + 10;
  
    doc.setFontSize(12).setFont("helvetica", "bold");
    doc.text("Consultant's / Nurse's Notes", 15, y);
    y += 5;
  
    const notesText = formData.tpa_notes || "-";
    const splitNotes = doc.splitTextToSize(notesText, pageWidth - 30);
    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text(splitNotes, 15, y);
    y += splitNotes.length * 6 + 6;
  
    const pageHeight = doc.internal.pageSize.getHeight();
    const footerY = pageHeight - 25;
    doc.setLineWidth(0.5);
    doc.line(15, footerY, 195, footerY);
    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text("Nurse's Signature", 35, footerY + 8, { align: "center" });
    doc.text("Doctor's Signature", 175, footerY + 8, { align: "center" });
    doc.setFontSize(8).setFont("helvetica", "italic");
    doc.text("This is a computer-generated report and does not require a physical signature.", pageWidth / 2, pageHeight - 10, { align: "center" });
  
    window.open(doc.output("bloburl"), "_blank");
  };

  
  const generatePDFPrint = async (rowItem) => {
    const item = rowItem || {};
    if (!item.tpa_patient) {
      Swal.fire("Error", "Patient data is not available.", "error");
      return;
    }
  
    const doc = new jsPDF("p", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();
    let y;
  
    const headerImageBase64 = await imageUrlToBase64(image);
    const headerImageHeight = 30;
    if (headerImageBase64) {
      doc.addImage(headerImageBase64, "PNG", 0, 0, pageWidth, headerImageHeight);
    }
    y = headerImageHeight + 8;
  
    doc.setFont("helvetica", "bold");
    doc.setFontSize(14);
    doc.text("NURSING MONITORING SHEET", pageWidth / 2, y, { align: "center" });
    y += 8;
  
    // ✅ Get doctor names
    const consultantName = item.tpa_consultant_name || 
                           getDoctorNameById(item.tpa_consultant) || 
                           item.tpa_consultant || 
                           "N/A";
    
    const surgeonName = item.tpa_ot_doctor_name || 
                        getDoctorNameById(item.tpa_ot_doctor) || 
                        item.tpa_ot_doctor || 
                        "N/A";
  
    // ✅ Convert time to 12-hour format
    const time12Hour = formatTimeTo12Hour(item.tpa_time);
    const formattedDate = formatDateToDDMMMYYYY(item.tpa_date);
    const patientDetailsBody = [
      [
        { content: "UHID", styles: { fontStyle: "bold" } }, 
        `: ${item.tpa_ipd_number || "N/A"}`, 
        { content: "TPR No", styles: { fontStyle: "bold" } }, 
        `: ${item.tpa_trp || "-"}`
      ],
      [
        { content: "Patient Name", styles: { fontStyle: "bold" } }, 
        `: ${item.tpa_patient || "N/A"}`, 
        { content: "Ward / Bed", styles: { fontStyle: "bold" } }, 
        `: ${getWardNameById(item.tpa_room) || item.tpa_room || "N/A"} / ${getBedNameById(item.tpa_bed) || item.tpa_bed || "-"}`
      ],
      [
        { content: "Consultant", styles: { fontStyle: "bold" } }, 
        `: ${consultantName}`,
        { content: "Surgeon", styles: { fontStyle: "bold" } }, 
        `: ${surgeonName}`
      ],
      [
        { content: "Report Date", styles: { fontStyle: "bold" } }, 
      `: ${formattedDate || "N/A"}`, 
        { content: "Report Time", styles: { fontStyle: "bold" } }, 
        `: ${time12Hour || "N/A"}` // ✅ Changed to 12-hour format
      ]
    ];
  
    autoTable(doc, {
      body: patientDetailsBody,
      startY: y,
      theme: "plain",
      styles: { fontSize: 10, cellPadding: 1 },
      columnStyles: { 
        0: { cellWidth: 30 }, 
        1: { cellWidth: 65 }, 
        2: { cellWidth: 30 }, 
        3: { cellWidth: "auto" } 
      },
    });
    y = doc.lastAutoTable.finalY + 10;
  
    doc.setFontSize(12).setFont("helvetica", "bold");
    doc.text("Vital Signs", 15, y);
    y += 3;
  
    const vitalsBody = [
      ["Pulse", item.tpa_pulse || "-", "Temperature", item.tpa_temprature || "-"],
      ["Blood Pressure (BP)", item.tpa_bp || "-", "SpO2", item.tpa_spo2 || "-"],
      ["Respiration", item.tpa_repritation || "-", "Weight", item.tpa_weight || "-"],
    ];
  
    autoTable(doc, {
      body: vitalsBody,
      startY: y,
      theme: "grid",
      styles: { fontSize: 10, cellPadding: 2, halign: "center" },
      headStyles: { fillColor: [220, 220, 220], textColor: 20 },
      columnStyles: { 0: { fontStyle: "bold", halign: "left" }, 2: { fontStyle: "bold", halign: "left" } },
    });
    y = doc.lastAutoTable.finalY + 10;
  
    doc.setFontSize(12).setFont("helvetica", "bold");
    doc.text("Doctor's / Nurse's Notes", 15, y);
    y += 5;
  
    const notesText = item.tpa_notes || "-";
    const splitNotes = doc.splitTextToSize(notesText, pageWidth - 30);
    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text(splitNotes, 15, y);
  
    const pageHeight = doc.internal.pageSize.getHeight();
    const footerY = pageHeight - 25;
    doc.setLineWidth(0.5);
    doc.line(15, footerY, 195, footerY);
    doc.setFontSize(10).setFont("helvetica", "normal");
    doc.text("Nurse's Signature", 35, footerY + 8, { align: "center" });
    doc.text("Doctor's Signature", 175, footerY + 8, { align: "center" });
  
    window.open(doc.output("bloburl"), "_blank");
  };





  
// Add this useEffect after the date/time useEffect
// Replace the existing useEffect for doctor resolution
useEffect(() => {
  const resolveNames = async () => {
    // Only try to resolve if we have IDs but no names
    if ((formData.tpa_consultant && !formData.tpa_consultant_name) || 
        (formData.tpa_ot_doctor && !formData.tpa_ot_doctor_name)) {
      console.log("🔄 useEffect triggered - resolving doctor names");
      await resolveDoctorNamesForForm();
    }
  };
  
  resolveNames();
}, [formData.tpa_consultant, formData.tpa_ot_doctor]);
  // ---------------------
  // Edit item
  // ---------------------
  const setEditItem = async (tmp) => {
    // Ensure doctors are loaded
    let docs = formData.doc;
    if (!docs || docs.length === 0) {
      docs = await fetchAllDoctors();
    }
  
    // Resolve doctor names
    const consultantName = resolveDoctorNameById(tmp.tpa_consultant, docs);
    const otDoctorName = resolveDoctorNameById(tmp.tpa_ot_doctor, docs);
  
    setFormData((prev) => ({
      ...prev,
      tpa_id: tmp.tpa_id,
      tpa_ipd_number: tmp.tpa_ipd_number,
      tpa_patient: tmp.tpa_patient,
      tpa_consultant: tmp.tpa_consultant,
      tpa_consultant_name: consultantName,
      tpa_ot_doctor: tmp.tpa_ot_doctor || "",
      tpa_ot_doctor_name: otDoctorName,
      tpa_trp: tmp.tpa_trp,
      tpa_temprature: tmp.tpa_temprature,
      tpa_bp: tmp.tpa_bp,
      tpa_fluid: tmp.tpa_fluid,
      tpa_spo2: tmp.tpa_spo2,
      tpa_uhid: tmp.tpa_uhid,
      tpa_room: tmp.tpa_room,
      tpa_bed: tmp.tpa_bed,
      tpa_panel: tmp.tpa_panel,
      tpa_date: tmp.tpa_date,
      tpa_time: tmp.tpa_time,
      tpa_pulse: tmp.tpa_pulse,
      tpa_stool: tmp.tpa_stool,
      tpa_weight: tmp.tpa_weight,
      tpa_repritation: tmp.tpa_repritation,
      tpa_urine: tmp.tpa_urine,
      tpa_cvp: tmp.tpa_cvp,
      tpa_user: tmp.tpa_user,
      tpa_notes: tmp.tpa_notes,
    }));
  };

  // ---------------------
  // DataTable columns
  // ---------------------
  const columns = [
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-sm btn-outline-info"
            onClick={async () => {
              const full = await fetchTpaById(row.tpa_id);
              if (full) generatePDFPrint(full);
              else generatePDFPrint(row);
            }}
            title="Print"
          >
            <i className="ri-printer-line"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-warning"
            onClick={() => setEditItem(row)}
            disabled={!isAdmin}
            title="Edit"
          >
            <i className="ri-pencil-fill"></i>
          </button>
          <button
            className="btn btn-sm btn-outline-danger"
            onClick={() => delItem(row)}
            disabled={!isAdmin}
            title="Delete"
          >
            <i className="ri-delete-bin-5-fill"></i>
          </button>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "140px",
    },
    {
      name: "Sr. No.",
      selector: (row, index) => index + 1,
      width: "80px",
      sortable: false,
    },
    {
      name: "TPR No",
      selector: (row) => row.tpa_trp || "-",
      sortable: true,
      width: "110px",
    },
    {
      name: "Patient",
      selector: (row) => row.tpa_patient || "-",
      sortable: true,
      wrap: true,
      width: "180px",
    },
    {
      name: "UHID",
      selector: (row) => row.tpa_ipd_number || "-",
      sortable: true,
      width: "120px",
    },
    {
      name: "Ward",
      selector: (row) => getWardNameById(row.tpa_room) || row.tpa_room || "-",
      sortable: true,
      width: "120px",
    },
    {
      name: "Bed",
      selector: (row) => getBedNameById(row.tpa_bed) || row.tpa_bed || "-",
      sortable: true,
      width: "100px",
    },
    {
      name: "Consultant Doctor",
      selector: (row) => row.tpa_consultant_name || getDoctorNameById(row.tpa_consultant) || "-",
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "OT Doctor",
      selector: (row) => row.tpa_ot_doctor_name || getDoctorNameById(row.tpa_ot_doctor) || "-",
      sortable: true,
      wrap: true,
      width: "150px",
    },
    {
      name: "Date",
      selector: (row) => formatDateToDDMMMYYYY(row.tpa_date) || "-",
      sortable: true,
      width: "130px",
    },
    
    {
      name: "Temp(°F)",
      selector: (row) => row.tpa_temprature || "-",
      sortable: true,
      width: "100px",
    },
    {
      name: "Pulse(bpm)",
      selector: (row) => row.tpa_pulse || "-",
      sortable: true,
      width: "110px",
    },
    
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#f1f5fb",
        color: "#405189",
        fontSize: "14px",
        fontWeight: "700",
      },
    },
    rows: {
      style: {
        minHeight: "52px",
      },
    },
  };

  // ---------------------
  // Render
  // ---------------------
  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-xxl-12">
            <div className="card">
              <div className="card-body">
                <h5 className="mb-3" style={{ color: "#405189" }}>
                  TPR Worksheet
                </h5>
                
                {/* Prefill indicator */}
                {formData.tpa_ipd_number && !formData.tpa_id && (
                  <div className="alert alert-info alert-dismissible fade show" role="alert">
                    <i className="ri-information-line me-2"></i>
                    <strong>Patient data loaded</strong> - UHID: {formData.tpa_ipd_number}
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setFormData((prev) => ({
                          ...prev,
                          tpa_ipd_number: "",
                          tpa_patient: "",
                          tpa_consultant: "",
                          tpa_room: "",
                          tpa_bed: "",
                        }));
                      }}
                    ></button>
                  </div>
                )}

                <div className="live-preview">
                  <form onSubmit={handleSubmit}>
                    <div className="row gy-3 mb-3">
                      <div className="col-md-3">
                        <div className="mb-1 position-relative">
                          <label htmlFor="tpa-uhid-field" className="form-label">
                            UHID Number <span className="text-danger">*</span>
                          </label>
                          <input
                            id="tpa-uhid-field"
                            name="tpa_ipd_number"
                            onChange={handleChange}
                            value={formData.tpa_ipd_number}
                            className="form-control"
                            placeholder="Enter UHID Number"
                            type="text"
                            onKeyUp={searchOtUserNow}
                            autoComplete="off"
                            required
                          />

                          {otUhidSuggestions.length > 0 && (
                            <ul className="list-group position-absolute w-100" style={{ zIndex: 10 }}>
                              {otUhidSuggestions.map((user, idx) => (
                                <li
                                  key={idx}
                                  className="list-group-item list-group-item-action"
                                  onClick={() => handleSelectOtUser(user)}
                                  style={{ cursor: "pointer" }}
                                >
                                  {user.lab_reg_uhid || user.ipd_uhid} - {user.lab_reg_name || user.ipd_patient_name}{" "}
                                  <span className="badge bg-info ms-2">{user.lab_reg_type || "IPD"}</span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div>
                          <label htmlFor="patient-field" className="form-label">
                            Patient Name <span className="text-danger">*</span>
                          </label>
                          <input
                            id="patient-field"
                            className="form-control"
                            name="tpa_patient"
                            onChange={handleChange}
                            value={formData.tpa_patient}
                            placeholder="Patient Name"
                            type="text"
                            required
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <div>
                          <label className="form-label">Consultant Doctor</label>
                          <input
  className="form-control"
  value={ formData.tpa_consultant_name || getDoctorNameById(formData.tpa_consultant) || formData.tpa_consultant || "" }

  placeholder="Consultant"
  type="text"
  readOnly
/>

                        </div>
                      </div>

{/* ✅ NEW: OT Doctor Field */}
<div className="col-md-3">
                        <div>
                          <label className="form-label">OT Doctor</label>
                          <input
  className="form-control"
  value={ formData.tpa_ot_doctor_name || getDoctorNameById(formData.tpa_ot_doctor) || formData.tpa_ot_doctor || "" }

  placeholder="OT Doctor"
  type="text"
  readOnly
/>

                        </div>
                      </div>


                      <div className="col-md-3">
                        <div>
                          <label className="form-label">TPR Number</label>
                          <input
                            className="form-control"
                            name="tpa_trp"
                            onChange={handleChange}
                            value={formData.tpa_trp}
                            placeholder="Auto-generated on save"
                            type="text"
                            readOnly
                            style={{ backgroundColor: "#e9ecef" }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Ward</label>
                          <input
                            className="form-control"
                            value={getWardNameById(formData.tpa_room)}
                            placeholder="Ward"
                            type="text"
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Bed</label>
                          <input
                            className="form-control"
                            value={getBedNameById(formData.tpa_bed) || formData.tpa_bed}
                            placeholder="Bed"
                            type="text"
                            readOnly
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Temperature (°F)</label>
                          <input
                            className="form-control"
                            name="tpa_temprature"
                            onChange={handleChange}
                            value={formData.tpa_temprature}
                            placeholder="Temperature"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">B.P.</label>
                          <input
                            className="form-control"
                            name="tpa_bp"
                            onChange={handleChange}
                            value={formData.tpa_bp}
                            placeholder="B.P."
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">SPO2 (%)</label>
                          <input
                            className="form-control"
                            name="tpa_spo2"
                            onChange={handleChange}
                            value={formData.tpa_spo2}
                            placeholder="SPO2"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Pulse (bpm)</label>
                          <input
                            className="form-control"
                            name="tpa_pulse"
                            onChange={handleChange}
                            value={formData.tpa_pulse}
                            placeholder="Pulse"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Respiration</label>
                          <input
                            className="form-control"
                            name="tpa_repritation"
                            onChange={handleChange}
                            value={formData.tpa_repritation}
                            placeholder="Respiration"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Weight (kg)</label>
                          <input
                            className="form-control"
                            name="tpa_weight"
                            onChange={handleChange}
                            value={formData.tpa_weight}
                            placeholder="Weight"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Panel</label>
                          <input
                            className="form-control"
                            name="tpa_panel"
                            onChange={handleChange}
                            value={formData.tpa_panel}
                            placeholder="Panel"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Date</label>
                          <input
                            className="form-control"
                            name="tpa_date"
                            onChange={handleChange}
                            value={formData.tpa_date}
                            type="date"
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div>
                          <label className="form-label">Time</label>
                          <input
                            className="form-control"
                            name="tpa_time"
                            onChange={handleChange}
                            value={formData.tpa_time}
                            type="time"
                          />
                        </div>
                      </div>

                      {/* Notes textarea full-width */}
                      <div className="col-md-12">
                        <div>
                          <label className="form-label">Notes / Observations</label>
                          <textarea
                            className="form-control"
                            name="tpa_notes"
                            onChange={handleChange}
                            value={formData.tpa_notes}
                            placeholder="Write notes here..."
                            rows="3"
                          />
                        </div>
                      </div>

                      <div className="col-md-12">
                        <div className="hstack gap-2 justify-content-end">
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Clear
                          </button>

                          {/* <button
  type="button"
  className="btn btn-info"
  onClick={async () => {
    // ✅ ALWAYS fetch fresh data if we have an ID
    const idToPrint = lastSavedTpaId || formData.tpa_id || null;
    
    if (idToPrint) {
      console.log("📋 Fetching fresh data for TPR ID:", idToPrint);
      const freshRow = await fetchTpaById(idToPrint);
      
      if (freshRow) {
        console.log("✅ Fresh TPR number:", freshRow.tpa_trp);
        generatePDFPrint(freshRow);
        return;
      }
    }
    
    // Fallback to current formData (for unsaved records)
    console.log("⚠️ Using current formData, TPR:", formData.tpa_trp);
    generatePDF();
  }}
>
  <i className="ri-printer-line me-1"></i> Print
</button> */}

                          <button type="submit" className="btn btn-success">
                            <i className="ri-save-line me-1"></i> Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
{/* --- List Filters: Search and Date Range --- */}
<div className="card mb-3">
  <div className="card-body">
    <div className="row g-2 align-items-end">
      <div className="col-md-4">
        <label className="form-label">Search (Name / UHID / TPR)</label>
        <input
          className="form-control"
          placeholder="Search patient, UHID or TPR number..."
          value={formData.search_key || ""}
          onChange={(e) => setFormData(prev => ({ ...prev, search_key: e.target.value }))}
          onKeyDown={(e) => { if (e.key === "Enter") initData(); }}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Date From</label>
        <input
          className="form-control"
          type="date"
          value={formData.date_from || ""}
          onChange={(e) => setFormData(prev => ({ ...prev, date_from: e.target.value }))}
        />
      </div>

      <div className="col-md-3">
        <label className="form-label">Date To</label>
        <input
          className="form-control"
          type="date"
          value={formData.date_to || ""}
          onChange={(e) => setFormData(prev => ({ ...prev, date_to: e.target.value }))}
        />
      </div>

      <div className="col-md-2 d-flex gap-2">
        {/* <button className="btn btn-primary w-100" onClick={() => initData()}>
          <i className="ri-search-line me-1"></i> Search
        </button> */}
        <button
  className="btn btn-outline-secondary w-100"
  onClick={() => {
    const today = todayIsoDate();
    setFormData(prev => ({ ...prev, search_key: "", date_from: today, date_to: today }));
    initData();
  }}
>
  Clear
</button>

      </div>
    </div>
  </div>
</div>

            <br />

            {/* DataTable List */}
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">TPR Records</h5>
              </div>
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={list}
                  pagination
                  highlightOnHover
                  responsive
                  persistTableHead
                  customStyles={customStyles}
                  progressPending={loadingList}
                  noHeader
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20, 50]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TprSheet;